export class AccountRole {
    code: string;
    name: string;
    description: string;
    sortBy: number;
}


// WEBPACK FOOTER //
// ./src/app/models/accountRole.ts